// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__tIirw","text":"Tooltip_text__Fm93x","condition":"Tooltip_condition__zEiJx"};